const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'commissionUserName',
        fixed: "left",
        render: defaultRender,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        render: defaultRender,
    },
    {
        title: 'Phone No',
        dataIndex: 'mobileNo',
        render: defaultRender,
    },
    {
        title: 'Commission User Name',
        dataIndex: 'contactName',
        render: defaultRender,
    },
    {
        title: 'Affiliate Id',
        dataIndex: 'affiliateId',
        render: defaultRender,
    },
    {
        title: 'Level',
        dataIndex: 'level',
        render: defaultRender,
    },
    {
        title: 'A/C Type',
        dataIndex: 'planName',
        render: defaultRender,
    },
    {
        title: 'A/C No.',
        dataIndex: 'terminalID',
        render: defaultRender,
    },
    {
        title: 'Lots',
        dataIndex: 'lots',
        render: defaultRender,
    },
    {
        title: 'Position Id',
        dataIndex: 'positionId',
        render: defaultRender,
    },
    {
        title: 'Symbol',
        dataIndex: 'symbol',
        render: defaultRender,
    },
    {
        title: 'Open Price',
        dataIndex: 'openPrice',
        render: defaultRender,
    },
    {
        title: 'Close Price',
        dataIndex: 'closePrice',
        render: defaultRender,
    },
    {
        title: 'Close Time',
        dataIndex: 'closeTime',
        render: defaultRender,
    },
    {
        title: 'Profit',
        dataIndex: 'profit',
        render: defaultRender,
    },
    {
        title: 'Commision',
        dataIndex: 'commision',
        render: defaultRender,
    },
    {
        title: 'createdDate',
        dataIndex: 'createdDate',
        render: defaultRender,
    },
];

export default columns;